import {
  GET_MOVIES_FAILURE,
  GET_MOVIES_REQUEST,
  GET_MOVIES_SUCCESS,
} from "../constant/movieList";

// const initialState = {
//   isLoading: false,
//   movieList: [],
//   error: null,
// };

const movieListReducer = (
  state = { isLoading: false, movieList: [], error: null },
  action
) => {
  switch (action.type) {
    case GET_MOVIES_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case GET_MOVIES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        movieList: action.payload,
      };
    case GET_MOVIES_FAILURE:
      return {
        ...state,
        isLoading: false,
        movieList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default movieListReducer;
